import UpdateStrip from './components/UpdateStrip';
import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import KeyNodes from './components/KeyNodes';
import CauseSection from './components/CauseSection';
import TimelineSection from './components/TimelineSection';
import FollowUpSection from './components/FollowUpSection';
import FaqSection from './components/FaqSection';
import DiscussionSection from './components/DiscussionSection';
import EntryResources from './components/EntryResources';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <div className="sticky top-0 z-50">
        <UpdateStrip />
        <SiteHeader />
      </div>

      <main>
        <Hero />
        <KeyNodes />
        <CauseSection />
        <TimelineSection />
        <FollowUpSection />
        <FaqSection />
        <DiscussionSection />
        <EntryResources />
      </main>

      <SiteFooter />
    </div>
  );
}